import Site from './site';
import { BaseEntity, JsonApiRelationship, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'route',
})
export default class Route extends BaseEntity {
  name: string = '';
  @JsonApiRelationship('site') site = new Site();

  constructor(id?: Route['id'], name: Route['name'] = '', site: Route['site'] = new Site()) {
    super();
    this.id = id;
    this.name = name;
    this.site = site;
  }
}

export interface RouteWithoutRelationships extends Omit<Route, 'site'> {}

export const toRouteWithoutRelationships = (route: Route): RouteWithoutRelationships => {
  return {
    id: route?.id,
    name: route?.name,
  };
};
